<template>
  <div class="platform-user-ui-permissions">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/platform-user/table">平台用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="always">
      <div slot="header">
        <span>修改<b>{{adminName}}</b>账户的权限</span>
      </div>
      <el-form label-width="100px">
        <el-form-item prop="roles"
                      style="max-width: 460px"
                      label="角色">
          <remote-select
            class="width-max"
            id-key="id"
            label-key="name"
            value-key="id"
            keyword-key="name"
            placeholder="请输入角色关键字"
            v-model="roles"
            multiple
            @change="onSelectRole"
            @findSuccess="onSelectRole"
            :query-request="getUiRolesIndex"
            :find-request="getUiRoleDetail" />
        </el-form-item>
        <el-form-item>
          <div style="margin-bottom: 15px;">
            <el-input
              placeholder="输入关键字进行过滤"
              v-model="filterText"
              style="width: 300px;margin-right: 10px;">
              <i slot="prefix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button @click="onExpand(true)">展 开
            </el-button>
            <el-button @click="onExpand(false)">收 起
            </el-button>
            <el-button @click="onSubmit"
                       type="primary">保 存
            </el-button>
          </div>
          <el-tree
            ref="tree"
            :data="platformUserUIPermissions"
            :default-expanded-keys="[-1]"
            :default-checked-keys="checkedPermissions"
            show-checkbox
            node-key="id"
            :expand-on-click-node="false"
            :filter-node-method="filterNode">
          </el-tree>
        </el-form-item>
      </el-form>
    </el-card>

    <el-backtop target="main"></el-backtop>
  </div>
</template>

<script>
import platformUserUIPermissions from '@views/platform-user/data/platform-user-ui-permissions.json'

export default {
  name: 'PlatformUserUIPermissions',
  data () {
    return {
      platformUserUIPermissions: _.cloneDeep(platformUserUIPermissions),
      filterText: '',
      checkedPermissions: [],
      roles: [],
      adminName: '',
    }
  },
  computed: {},
  watch: {
    filterText: _.debounce(function (val) {
      this.$refs.tree.filter(val)
    }, 250)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    ...request.map([
      'getUiRolesIndex',
      'getUiRoleDetail'
    ]),
    filterNode (value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    getCheckedKeys () {
      return this.$refs.tree.getCheckedKeys().filter(v => v > 0)
    },
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.page('findPermissions', id).then(({data}) => {
        this.adminName = data.name
        this.checkedPermissions = data.permission
        this.roles = data.roles

        this.updateTreeByRoles(data.roles)
      })
    },
    getForm () {
      return this.getCheckedKeys()
    },
    onSubmit () {
      this.update(this.id)
    },
    update (id) {
      request.common('updatePermissions', {
        route: id,
        data: {
          permission: this.getForm(),
          roles: this.roles
        }
      }).then((res) => {
        this.$confirm(this.$route.name + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/platform-user/table/'})
        })
      })
    },
    onExpand (expanded = true) {
      this.$refs.tree.root.childNodes[0].childNodes.forEach(node => {
        node.expanded = expanded
      })
    },
    updateTreeByRoles (roleIds) {
      if (roleIds.length === 0) {
        return this.updateTree(this.checkedPermissions, [])
      }
      request.common('getUiRolePermissionsIndex', {role_ids: roleIds}).then(({data}) => {
        this.updateTree(this.checkedPermissions, data.permission)
      })
    },
    onSelectRole () {
      this.updateTreeByRoles(this.roles)
    },
    updateTree (userPermissions, rolePermissions) {
      const checkedKeys = rolePermissions.concat(userPermissions)

      this.$refs.tree.setCheckedKeys(checkedKeys)
      this.disableTree(rolePermissions.map(one => one * 1), this.platformUserUIPermissions)
    },
    disableTree (permissions, collection) {
      for (let i in collection) {
        if (collection.hasOwnProperty(i)) {
          collection[i].disabled = permissions.includes(collection[i].id)
          if (collection[i].children && collection[i].children.length > 0) {
            this.disableTree(permissions, collection[i].children)
          }
        }
      }
    }
  },
}
</script>

<style lang="scss">
.platform-user-ui-permissions {
  .el-tree-node__label {
    margin-left: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/platform-user/pages/PlatformUserUIPermissions.vue